<!--  -->
<template>
  <div>
    <video id="video" preload autoplay loop muted ></video>
    <canvas id="canvas" width="500" height="500"  style="position: absolute;top: 55px;left: 25px;"></canvas> 
  </div>
</template>

<script>
require("tracking/build/tracking-min.js");
require("tracking/build/data/face-min.js");
require("tracking/build/data/mouth-min.js");
require("tracking/examples/assets/stats.min.js");
export default {
  name: "componentName",
  data() {
    return {
      videoEle: null,
      trackerTask: null,
      first: null,
      stream: {},
    };
  },
  props: {
    visibleFlag: Boolean,
  },
  created() {},
  methods: {
    openCamera() {
      var video = document.getElementById("video");
      this.videoEle = video;
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d");

      var tracker = new tracking.ObjectTracker("face"); // 引入第三方 库
      tracker.setInitialScale(1);
      tracker.setStepSize(2);
      tracker.setEdgesDensity(0.1);

      this.trackerTask = tracking.track("#video", tracker, { camera: true });
      //-------  指定 canvas 的宽高 ，auto 自动播放
      let constraints = {
        video: { width: 500, height: 500 },
        audio: true,
      };

      let promise = navigator.mediaDevices.getUserMedia(constraints); // h5 新的API

      promise
        .then((MediaStream) => {
          video.srcObject = MediaStream;
          this.stream = MediaStream;
          video.play();
        })
        .catch(function(PermissionDeniedError) {
          console.log(PermissionDeniedError);
        });
      //--------------
      let that = this;

      that.tracker_fun(tracker, video, context, canvas); //open 摄像头，执行tracker_fun( 传入参数 )
    },
    tracker_fun(tracker, video, context, canvas) {
      let that = this;
      tracker.on("track", function(event) {
        // 视频流
        context.clearRect(0, 0, canvas.width, canvas.height);
        console.log("come here");
        context.drawImage(video, 0, 0, 500, 500); // 绘制到 canvas
        if (!that.first) {
          // if  --- > else  检测到人脸 success() =>{}
          event.data.forEach(function(rect) {
            if (rect.x) {
              that.first = rect.x;
              //video.pause(); // success  将暂停 video
              // console.log(rect);
              //console.log(video);
              // context.drawImage(video, 0, 0, 500, 500); // 绘制到 canvas
              context.font = "11px Helvetica";
              context.fillText("", 100, 40);
              context.strokeStyle = "#a64ceb";
              context.strokeRect(rect.x, rect.y, rect.width, rect.height);
              //  var data_url = canvas.toDataURL("image/png"); //base64 request
              //console.log(data_url);
              //video.load();
              that.first = null;
              //that.tracker_fun(tracker, video, context, canvas);
              return;
            } else {
              context.font = "11px Helvetica";
              // context.fillText("", 100, 40);
              // context.strokeStyle = "#a64ceb";
              //context.strokeRect(rect.x, rect.y, rect.width, rect.height);
              //var data_url = canvas.toDataURL("image/png"); //base64 request
            }
          });
        }
      });
      // set_clear = setTimeout(function() {
      //   // 每秒 检测人脸 结果

      //   clearTimeout(set_clear);
      //   console.log("-------");
      // }, 5000);
    },
    stopMediaStreamTrack() {
      if (typeof this.stream === "object") {
        //	this.videoEl是视频流容器，也就是video标签，需要在data中声明这个变量，然后在打开摄像头的方法中this.videoEl.srcObject = window.stream
        this.videoEle.srcObject = null;
        this.stream.getTracks().forEach((track) => track.stop());
      }
    },
  },
  mounted() {
    this.openCamera();
  },
  watch: {
    visibleFlag(newVal) {
      if (!newVal) {
        this.stopMediaStreamTrack();
      } else {
        this.openCamera();
      }
    },
  },
  beforeDestroy() {
    // 停止侦测
    this.stopMediaStreamTrack();
  },
};
</script>
<style scoped>
</style>
